const getRunTimeConfig = () => {
  if (typeof (<any>window).bxTicketSearchAppParams === 'object') {
    return (<any>window).bxTicketSearchAppParams || {};
  }

  return {};
};

export const environment = Object.freeze({
  zendeskBaseUrl: new URLSearchParams(window.location.search).get('origin'),
  billingUnitNumberLookupCustomFieldId: import.meta.env
    .VITE_BILLING_UNIT_NUMBER_LOOKUP_CUSTOM_FIELD_ID,
  additionalBillingUnitsCustomFieldId: import.meta.env
    .VITE_ADDITIONAL_BILLING_UNITS_CUSTOM_FIELD_ID,
  billingUnitNumberCustomObjectKey: import.meta.env
    .VITE_BILLING_UNIT_NUMBER_CUSTOM_OBJECT_KEY,
  environment: import.meta.env.VITE_ENVIRONMENT,
  sentryDSN: import.meta.env.VITE_SENTRY_DSN,

  /**
   * Allow config specified at run time to override everything above.
   */
  ...getRunTimeConfig(),
});

declare interface BxTicketSearchAppWindow extends Window {
  zendeskBaseUrl: string;
  billingUnitNumberLookupCustomFieldId: string;
  additionalBillingUnitsCustomFieldId: string;
  billingUnitNumberCustomObjectKey: string;
  environment: string;
  sentryDSN: string;
}

declare const window: BxTicketSearchAppWindow | typeof globalThis;
